'use strict';
const mmWidgets = require('./mm-widgets');
mmWidgets.fn.macifyHotkeys = function (navigatorModel) {
	if (!navigatorModel.isMac()) {
		return this;
	}
	return mmWidgets.each(this, function () {
		const element = this.domElements[0],
			hotkey = element.getAttribute('data-mm-hotkey');
		if (/\^/.test(hotkey)) {
			element.setAttribute('data-mm-hotkey', hotkey.replace('^', String.fromCharCode(8984)));
		}
	});
};
